// Action Types
export const UPDATE_PDF_DATA = 'UPDATE_PDF_DATA';

// Action Creator
export const updatePdfData = (key, data) => ({
  type: UPDATE_PDF_DATA,
  payload: { key, data }
});
